import React from 'react';
import { MdArrowForward } from 'react-icons/md';
import { Link } from 'react-router-dom';
import '../../styles/home/RegionSection.css';

const RegionSection: React.FC = () => {
  return (
    <section className="region">
      <div className="region__container">
        {/* ── Left: Text ── */}
        <div className="region__content">
          <span className="region__tag">COVERAGE & RELIABILITY</span>
          <h2 className="region__heading">
            Operating Across Your Region with Precision
          </h2>
          <p className="region__subtitle">
            Our delivery network is mapped, optimized, and continuously
            monitored — so your orders reach the right places, on schedule,
            every time.
          </p>
          <Link to="/contact" className="region__cta">
            Talk to VIN Services <MdArrowForward />
          </Link>
        </div>

        {/* ── Right: Radar Map + Stats ── */}
        <div className="region__visual">
          <div className="region__radar">
            {/* Grid lines */}
            <div className="region__radar-grid">
              {Array.from({ length: 7 }).map((_, i) => (
                <div key={`h-${i}`} className="region__radar-grid-h" style={{ top: `${(i + 1) * 12.5}%` }} />
              ))}
              {Array.from({ length: 9 }).map((_, i) => (
                <div key={`v-${i}`} className="region__radar-grid-v" style={{ left: `${(i + 1) * 10}%` }} />
              ))}
            </div>

            {/* Crosshair */}
            <div className="region__radar-crosshair-v" />
            <div className="region__radar-crosshair-h" />

            {/* Center dot (blue) */}
            <div className="region__radar-center">
              <span className="region__radar-center-pulse" />
              <span className="region__radar-center-dot" />
            </div>

            {/* Green location dots */}
            <span className="region__radar-dot" style={{ top: '18%', left: '48%' }} />
            <span className="region__radar-dot" style={{ top: '62%', left: '30%' }} />
            <span className="region__radar-dot" style={{ top: '60%', left: '65%' }} />
            <span className="region__radar-dot" style={{ top: '35%', left: '72%' }} />
          </div>

          {/* Stats row below radar */}
          <div className="region__stats">
            <div className="region__stat">
              <span className="region__stat-value">47</span>
              <span className="region__stat-label">Active Routes</span>
            </div>
            <div className="region__stat-divider" />
            <div className="region__stat">
              <span className="region__stat-value">315</span>
              <span className="region__stat-label">Deliveries Today</span>
            </div>
            <div className="region__stat-divider" />
            <div className="region__stat">
              <span className="region__stat-value">98%</span>
              <span className="region__stat-label">Accuracy</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegionSection;
